import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { dashboardActions } from '../../../../store/slices/dashboardSlice/dashboardSlice';

export const useWeatherModal = () => {
    const dispatch = useDispatch();

    //@ts-ignore
    const { modalMode, information } = useSelector((state) => state.dashboardReducer);

    const onCancel = useCallback(() => {
        dispatch(dashboardActions.onModalMode(null));
    }, []);
    return { modalMode, onCancel, information };
};
